import { createSlice } from "@reduxjs/toolkit";
import { Source } from 'types/Source';

interface sourceSlice {
  sources: Source[],
}

// Define the initial state using that type
const initialState: sourceSlice = {
  sources: [],
};

export const sourceSlice = createSlice({
  name: "sources",
  initialState: initialState,
  reducers: {
    addSources: (state, action) => {
      state.sources = action.payload.sources;
    },

    addSource: (state, action) => {
      const newSource = {
        _id: action.payload._id,
        name: action.payload.name,
        abbr: action.payload.abbr,
        code: action.payload.code,
        isDeleted: action.payload.isDeleted,
      }
      state.sources.push(newSource);
    },
    updateSource: (state, action) => {
      const updatedSource = {
        _id: action.payload._id,
        name: action.payload.name,
        abbr: action.payload.abbr,
        code: action.payload.code,
        isDeleted: action.payload.isDeleted,
      }
      const index = state.sources.findIndex((source: any) => source._id === action.payload._id);
      state.sources[index] = updatedSource;
    },
    deleteSource: (state, action) => {
      const _id = action.payload._id;
      state.sources = [...state.sources.filter((source: any) => source._id !== _id)];
    }
  },
});

export const { addSources, addSource, updateSource, deleteSource } = sourceSlice.actions;
export default sourceSlice.reducer;